import { ENUM__ml_asset_family } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_family';

export const EPageDiffusionModelsFilterBaseModel = {
  ALL: 'ALL',
  ...ENUM__ml_asset_family,
};
